/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {convertFetchResponseToReactQueryResponse} from '../tools';
import {ApiResponse} from '../types';
import {
    useMutation,
    UseMutationOptions,
    UseMutationResult,
    useQuery,
    useQueryClient,
    UseQueryOptions,
    UseQueryResult,
    QueryClient,
    useInfiniteQuery,
    UseInfiniteQueryOptions,
    UseInfiniteQueryResult,
} from 'react-query';
import {
    AdminAssignProductToGroupSale,
    AdminAssignProductToGroupSaleFromJSON,
    AdminAssignProductToGroupSaleToJSON,
    AdminCategoryListResp,
    AdminCategoryListRespFromJSON,
    AdminCategoryListRespToJSON,
    AdminCreateProduct,
    AdminCreateProductFromJSON,
    AdminCreateProductToJSON,
    AdminDownloadListImages,
    AdminDownloadListImagesFromJSON,
    AdminDownloadListImagesToJSON,
    AdminPrintLabelRequest,
    AdminPrintLabelRequestFromJSON,
    AdminPrintLabelRequestToJSON,
    AdminPrintLabelResponse,
    AdminPrintLabelResponseFromJSON,
    AdminPrintLabelResponseToJSON,
    AdminProductConsistencyDescriptionsResp,
    AdminProductConsistencyDescriptionsRespFromJSON,
    AdminProductConsistencyDescriptionsRespToJSON,
    AdminProductCreateResp,
    AdminProductCreateRespFromJSON,
    AdminProductCreateRespToJSON,
    AdminProductDetail,
    AdminProductDetailFromJSON,
    AdminProductDetailToJSON,
    AdminProductDetailImage,
    AdminProductDetailImageFromJSON,
    AdminProductDetailImageToJSON,
    AdminProductListResp,
    AdminProductListRespFromJSON,
    AdminProductListRespToJSON,
    AdminRotateImageReq,
    AdminRotateImageReqFromJSON,
    AdminRotateImageReqToJSON,
    AdminUpdateProduct,
    AdminUpdateProductFromJSON,
    AdminUpdateProductToJSON,
    AdminUpdateProductsStatus,
    AdminUpdateProductsStatusFromJSON,
    AdminUpdateProductsStatusToJSON,
} from '../models';

import {
    ProductsApi,
    ProductsApiDeleteAdminDeleteImageRequest,
    ProductsApiGetAdminDownloadProductImagesRequest,
    ProductsApiGetAdminProductDetailRequest,
    ProductsApiGetAdminProductDownloadImageRequest,
    ProductsApiPostAdminAssignProductsToGroupSaleRequest,
    ProductsApiPostAdminAttachImagesRequest,
    ProductsApiPostAdminPrintLabelRequest,
    ProductsApiPostAdminProductCreateRequest,
    ProductsApiPostAdminProductListRequest,
    ProductsApiPostAdminRotateImageRequest,
    ProductsApiPostAdminUpdateProductsStatusRequest,
    ProductsApiPutAdminProductUpdateRequest,
} from './ProductsApi';

type DeleteAdminDeleteImageQueryOptions = UseQueryOptions<
    void,
    Array<Error>,
    void,
    ['deleteAdminDeleteImage', ProductsApiDeleteAdminDeleteImageRequest]
>;

let useDeleteAdminDeleteImageQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: ProductsApiDeleteAdminDeleteImageRequest,
          options?: DeleteAdminDeleteImageQueryOptions
      ) => DeleteAdminDeleteImageQueryOptions | undefined)
    | undefined = undefined;

export function registerUseDeleteAdminDeleteImageQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: ProductsApiDeleteAdminDeleteImageRequest,
        options?: DeleteAdminDeleteImageQueryOptions
    ) => DeleteAdminDeleteImageQueryOptions | undefined
) {
    useDeleteAdminDeleteImageQueryGlobalOptions = callback;
}

export function getDeleteAdminDeleteImageQueryKey(
    params: ProductsApiDeleteAdminDeleteImageRequest
): ['deleteAdminDeleteImage', ProductsApiDeleteAdminDeleteImageRequest] {
    return ['deleteAdminDeleteImage', params];
}

export function useDeleteAdminDeleteImageQuery(
    params: ProductsApiDeleteAdminDeleteImageRequest,
    options?: DeleteAdminDeleteImageQueryOptions
): UseQueryResult<void, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getDeleteAdminDeleteImageQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new ProductsApi().deleteAdminDeleteImage(params, {signal})),
        {
            ...options,
            ...useDeleteAdminDeleteImageQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type DeleteAdminDeleteImageMutationOptions = UseMutationOptions<
    void,
    Array<Error>,
    ProductsApiDeleteAdminDeleteImageRequest
>;

let useDeleteAdminDeleteImageMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: DeleteAdminDeleteImageMutationOptions
      ) => DeleteAdminDeleteImageMutationOptions | undefined)
    | undefined = undefined;

export function registerUseDeleteAdminDeleteImageMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: DeleteAdminDeleteImageMutationOptions
    ) => DeleteAdminDeleteImageMutationOptions | undefined
) {
    useDeleteAdminDeleteImageMutationGlobalOptions = callback;
}

export function useDeleteAdminDeleteImageMutation(
    options?: DeleteAdminDeleteImageMutationOptions
): UseMutationResult<void, Array<runtime.ApiError>, ProductsApiDeleteAdminDeleteImageRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new ProductsApi().deleteAdminDeleteImage(params)),
        {
            ...options,
            ...useDeleteAdminDeleteImageMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getDeleteAdminDeleteImageInfiniteQueryKey(
    params: ProductsApiDeleteAdminDeleteImageRequest
): ['deleteAdminDeleteImage-infinite', ProductsApiDeleteAdminDeleteImageRequest] {
    return ['deleteAdminDeleteImage-infinite', params];
}

export function useDeleteAdminDeleteImageInfiniteQuery(
    params: ProductsApiDeleteAdminDeleteImageRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            void,
            Array<runtime.ApiError>,
            void,
            void,
            ['deleteAdminDeleteImage-infinite', ProductsApiDeleteAdminDeleteImageRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<void, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getDeleteAdminDeleteImageInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new ProductsApi().deleteAdminDeleteImage({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type GetAdminDownloadProductImagesQueryOptions = UseQueryOptions<
    Blob,
    Array<Error>,
    Blob,
    ['getAdminDownloadProductImages', ProductsApiGetAdminDownloadProductImagesRequest]
>;

let useGetAdminDownloadProductImagesQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: ProductsApiGetAdminDownloadProductImagesRequest,
          options?: GetAdminDownloadProductImagesQueryOptions
      ) => GetAdminDownloadProductImagesQueryOptions | undefined)
    | undefined = undefined;

export function registerUseGetAdminDownloadProductImagesQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: ProductsApiGetAdminDownloadProductImagesRequest,
        options?: GetAdminDownloadProductImagesQueryOptions
    ) => GetAdminDownloadProductImagesQueryOptions | undefined
) {
    useGetAdminDownloadProductImagesQueryGlobalOptions = callback;
}

export function getGetAdminDownloadProductImagesQueryKey(
    params: ProductsApiGetAdminDownloadProductImagesRequest
): ['getAdminDownloadProductImages', ProductsApiGetAdminDownloadProductImagesRequest] {
    return ['getAdminDownloadProductImages', params];
}

export function useGetAdminDownloadProductImagesQuery(
    params: ProductsApiGetAdminDownloadProductImagesRequest,
    options?: GetAdminDownloadProductImagesQueryOptions
): UseQueryResult<Blob, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getGetAdminDownloadProductImagesQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(
                await new ProductsApi().getAdminDownloadProductImages(params, {signal})
            ),
        {
            ...options,
            ...useGetAdminDownloadProductImagesQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type GetAdminDownloadProductImagesMutationOptions = UseMutationOptions<
    Blob,
    Array<Error>,
    ProductsApiGetAdminDownloadProductImagesRequest
>;

let useGetAdminDownloadProductImagesMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: GetAdminDownloadProductImagesMutationOptions
      ) => GetAdminDownloadProductImagesMutationOptions | undefined)
    | undefined = undefined;

export function registerUseGetAdminDownloadProductImagesMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: GetAdminDownloadProductImagesMutationOptions
    ) => GetAdminDownloadProductImagesMutationOptions | undefined
) {
    useGetAdminDownloadProductImagesMutationGlobalOptions = callback;
}

export function useGetAdminDownloadProductImagesMutation(
    options?: GetAdminDownloadProductImagesMutationOptions
): UseMutationResult<Blob, Array<runtime.ApiError>, ProductsApiGetAdminDownloadProductImagesRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new ProductsApi().getAdminDownloadProductImages(params)),
        {
            ...options,
            ...useGetAdminDownloadProductImagesMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getGetAdminDownloadProductImagesInfiniteQueryKey(
    params: ProductsApiGetAdminDownloadProductImagesRequest
): ['getAdminDownloadProductImages-infinite', ProductsApiGetAdminDownloadProductImagesRequest] {
    return ['getAdminDownloadProductImages-infinite', params];
}

export function useGetAdminDownloadProductImagesInfiniteQuery(
    params: ProductsApiGetAdminDownloadProductImagesRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            Blob,
            Array<runtime.ApiError>,
            Blob,
            Blob,
            ['getAdminDownloadProductImages-infinite', ProductsApiGetAdminDownloadProductImagesRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<Blob, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getGetAdminDownloadProductImagesInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new ProductsApi().getAdminDownloadProductImages({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type GetAdminProductCategoryListQueryOptions = UseQueryOptions<
    AdminCategoryListResp,
    Array<Error>,
    AdminCategoryListResp,
    ['getAdminProductCategoryList']
>;

let useGetAdminProductCategoryListQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: GetAdminProductCategoryListQueryOptions
      ) => GetAdminProductCategoryListQueryOptions | undefined)
    | undefined = undefined;

export function registerUseGetAdminProductCategoryListQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: GetAdminProductCategoryListQueryOptions
    ) => GetAdminProductCategoryListQueryOptions | undefined
) {
    useGetAdminProductCategoryListQueryGlobalOptions = callback;
}

export function getGetAdminProductCategoryListQueryKey(): ['getAdminProductCategoryList'] {
    return ['getAdminProductCategoryList'];
}

export function useGetAdminProductCategoryListQuery(
    options?: GetAdminProductCategoryListQueryOptions
): UseQueryResult<AdminCategoryListResp, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getGetAdminProductCategoryListQueryKey(),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new ProductsApi().getAdminProductCategoryList({signal})),
        {
            ...options,
            ...useGetAdminProductCategoryListQueryGlobalOptions?.(queryClient, options),
        }
    );
}

type GetAdminProductCategoryListMutationOptions = UseMutationOptions<AdminCategoryListResp, Array<Error>>;

let useGetAdminProductCategoryListMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: GetAdminProductCategoryListMutationOptions
      ) => GetAdminProductCategoryListMutationOptions | undefined)
    | undefined = undefined;

export function registerUseGetAdminProductCategoryListMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: GetAdminProductCategoryListMutationOptions
    ) => GetAdminProductCategoryListMutationOptions | undefined
) {
    useGetAdminProductCategoryListMutationGlobalOptions = callback;
}

export function useGetAdminProductCategoryListMutation(
    options?: GetAdminProductCategoryListMutationOptions
): UseMutationResult<AdminCategoryListResp, Array<runtime.ApiError>, void> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new ProductsApi().getAdminProductCategoryList()),
        {
            ...options,
            ...useGetAdminProductCategoryListMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getGetAdminProductCategoryListInfiniteQueryKey(): ['getAdminProductCategoryList-infinite'] {
    return ['getAdminProductCategoryList-infinite'];
}

export function useGetAdminProductCategoryListInfiniteQuery(
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminCategoryListResp,
            Array<runtime.ApiError>,
            AdminCategoryListResp,
            AdminCategoryListResp,
            ['getAdminProductCategoryList-infinite']
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminCategoryListResp, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getGetAdminProductCategoryListInfiniteQueryKey(),
        async (context) =>
            convertFetchResponseToReactQueryResponse(await new ProductsApi().getAdminProductCategoryList()),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type GetAdminProductDetailQueryOptions = UseQueryOptions<
    AdminProductDetail,
    Array<Error>,
    AdminProductDetail,
    ['getAdminProductDetail', ProductsApiGetAdminProductDetailRequest]
>;

let useGetAdminProductDetailQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: ProductsApiGetAdminProductDetailRequest,
          options?: GetAdminProductDetailQueryOptions
      ) => GetAdminProductDetailQueryOptions | undefined)
    | undefined = undefined;

export function registerUseGetAdminProductDetailQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: ProductsApiGetAdminProductDetailRequest,
        options?: GetAdminProductDetailQueryOptions
    ) => GetAdminProductDetailQueryOptions | undefined
) {
    useGetAdminProductDetailQueryGlobalOptions = callback;
}

export function getGetAdminProductDetailQueryKey(
    params: ProductsApiGetAdminProductDetailRequest
): ['getAdminProductDetail', ProductsApiGetAdminProductDetailRequest] {
    return ['getAdminProductDetail', params];
}

export function useGetAdminProductDetailQuery(
    params: ProductsApiGetAdminProductDetailRequest,
    options?: GetAdminProductDetailQueryOptions
): UseQueryResult<AdminProductDetail, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getGetAdminProductDetailQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new ProductsApi().getAdminProductDetail(params, {signal})),
        {
            ...options,
            ...useGetAdminProductDetailQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type GetAdminProductDetailMutationOptions = UseMutationOptions<
    AdminProductDetail,
    Array<Error>,
    ProductsApiGetAdminProductDetailRequest
>;

let useGetAdminProductDetailMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: GetAdminProductDetailMutationOptions
      ) => GetAdminProductDetailMutationOptions | undefined)
    | undefined = undefined;

export function registerUseGetAdminProductDetailMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: GetAdminProductDetailMutationOptions
    ) => GetAdminProductDetailMutationOptions | undefined
) {
    useGetAdminProductDetailMutationGlobalOptions = callback;
}

export function useGetAdminProductDetailMutation(
    options?: GetAdminProductDetailMutationOptions
): UseMutationResult<AdminProductDetail, Array<runtime.ApiError>, ProductsApiGetAdminProductDetailRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new ProductsApi().getAdminProductDetail(params)),
        {
            ...options,
            ...useGetAdminProductDetailMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getGetAdminProductDetailInfiniteQueryKey(
    params: ProductsApiGetAdminProductDetailRequest
): ['getAdminProductDetail-infinite', ProductsApiGetAdminProductDetailRequest] {
    return ['getAdminProductDetail-infinite', params];
}

export function useGetAdminProductDetailInfiniteQuery(
    params: ProductsApiGetAdminProductDetailRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminProductDetail,
            Array<runtime.ApiError>,
            AdminProductDetail,
            AdminProductDetail,
            ['getAdminProductDetail-infinite', ProductsApiGetAdminProductDetailRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminProductDetail, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getGetAdminProductDetailInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new ProductsApi().getAdminProductDetail({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type GetAdminProductDownloadImageQueryOptions = UseQueryOptions<
    Blob,
    Array<Error>,
    Blob,
    ['getAdminProductDownloadImage', ProductsApiGetAdminProductDownloadImageRequest]
>;

let useGetAdminProductDownloadImageQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: ProductsApiGetAdminProductDownloadImageRequest,
          options?: GetAdminProductDownloadImageQueryOptions
      ) => GetAdminProductDownloadImageQueryOptions | undefined)
    | undefined = undefined;

export function registerUseGetAdminProductDownloadImageQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: ProductsApiGetAdminProductDownloadImageRequest,
        options?: GetAdminProductDownloadImageQueryOptions
    ) => GetAdminProductDownloadImageQueryOptions | undefined
) {
    useGetAdminProductDownloadImageQueryGlobalOptions = callback;
}

export function getGetAdminProductDownloadImageQueryKey(
    params: ProductsApiGetAdminProductDownloadImageRequest
): ['getAdminProductDownloadImage', ProductsApiGetAdminProductDownloadImageRequest] {
    return ['getAdminProductDownloadImage', params];
}

export function useGetAdminProductDownloadImageQuery(
    params: ProductsApiGetAdminProductDownloadImageRequest,
    options?: GetAdminProductDownloadImageQueryOptions
): UseQueryResult<Blob, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getGetAdminProductDownloadImageQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(
                await new ProductsApi().getAdminProductDownloadImage(params, {signal})
            ),
        {
            ...options,
            ...useGetAdminProductDownloadImageQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type GetAdminProductDownloadImageMutationOptions = UseMutationOptions<
    Blob,
    Array<Error>,
    ProductsApiGetAdminProductDownloadImageRequest
>;

let useGetAdminProductDownloadImageMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: GetAdminProductDownloadImageMutationOptions
      ) => GetAdminProductDownloadImageMutationOptions | undefined)
    | undefined = undefined;

export function registerUseGetAdminProductDownloadImageMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: GetAdminProductDownloadImageMutationOptions
    ) => GetAdminProductDownloadImageMutationOptions | undefined
) {
    useGetAdminProductDownloadImageMutationGlobalOptions = callback;
}

export function useGetAdminProductDownloadImageMutation(
    options?: GetAdminProductDownloadImageMutationOptions
): UseMutationResult<Blob, Array<runtime.ApiError>, ProductsApiGetAdminProductDownloadImageRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new ProductsApi().getAdminProductDownloadImage(params)),
        {
            ...options,
            ...useGetAdminProductDownloadImageMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getGetAdminProductDownloadImageInfiniteQueryKey(
    params: ProductsApiGetAdminProductDownloadImageRequest
): ['getAdminProductDownloadImage-infinite', ProductsApiGetAdminProductDownloadImageRequest] {
    return ['getAdminProductDownloadImage-infinite', params];
}

export function useGetAdminProductDownloadImageInfiniteQuery(
    params: ProductsApiGetAdminProductDownloadImageRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            Blob,
            Array<runtime.ApiError>,
            Blob,
            Blob,
            ['getAdminProductDownloadImage-infinite', ProductsApiGetAdminProductDownloadImageRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<Blob, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getGetAdminProductDownloadImageInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new ProductsApi().getAdminProductDownloadImage({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type GetAdminProductsConsistencyDetailsQueryOptions = UseQueryOptions<
    AdminProductConsistencyDescriptionsResp,
    Array<Error>,
    AdminProductConsistencyDescriptionsResp,
    ['getAdminProductsConsistencyDetails']
>;

let useGetAdminProductsConsistencyDetailsQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: GetAdminProductsConsistencyDetailsQueryOptions
      ) => GetAdminProductsConsistencyDetailsQueryOptions | undefined)
    | undefined = undefined;

export function registerUseGetAdminProductsConsistencyDetailsQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: GetAdminProductsConsistencyDetailsQueryOptions
    ) => GetAdminProductsConsistencyDetailsQueryOptions | undefined
) {
    useGetAdminProductsConsistencyDetailsQueryGlobalOptions = callback;
}

export function getGetAdminProductsConsistencyDetailsQueryKey(): ['getAdminProductsConsistencyDetails'] {
    return ['getAdminProductsConsistencyDetails'];
}

export function useGetAdminProductsConsistencyDetailsQuery(
    options?: GetAdminProductsConsistencyDetailsQueryOptions
): UseQueryResult<AdminProductConsistencyDescriptionsResp, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getGetAdminProductsConsistencyDetailsQueryKey(),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(
                await new ProductsApi().getAdminProductsConsistencyDetails({signal})
            ),
        {
            ...options,
            ...useGetAdminProductsConsistencyDetailsQueryGlobalOptions?.(queryClient, options),
        }
    );
}

type GetAdminProductsConsistencyDetailsMutationOptions = UseMutationOptions<
    AdminProductConsistencyDescriptionsResp,
    Array<Error>
>;

let useGetAdminProductsConsistencyDetailsMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: GetAdminProductsConsistencyDetailsMutationOptions
      ) => GetAdminProductsConsistencyDetailsMutationOptions | undefined)
    | undefined = undefined;

export function registerUseGetAdminProductsConsistencyDetailsMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: GetAdminProductsConsistencyDetailsMutationOptions
    ) => GetAdminProductsConsistencyDetailsMutationOptions | undefined
) {
    useGetAdminProductsConsistencyDetailsMutationGlobalOptions = callback;
}

export function useGetAdminProductsConsistencyDetailsMutation(
    options?: GetAdminProductsConsistencyDetailsMutationOptions
): UseMutationResult<AdminProductConsistencyDescriptionsResp, Array<runtime.ApiError>, void> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new ProductsApi().getAdminProductsConsistencyDetails()),
        {
            ...options,
            ...useGetAdminProductsConsistencyDetailsMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getGetAdminProductsConsistencyDetailsInfiniteQueryKey(): [
    'getAdminProductsConsistencyDetails-infinite',
] {
    return ['getAdminProductsConsistencyDetails-infinite'];
}

export function useGetAdminProductsConsistencyDetailsInfiniteQuery(
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminProductConsistencyDescriptionsResp,
            Array<runtime.ApiError>,
            AdminProductConsistencyDescriptionsResp,
            AdminProductConsistencyDescriptionsResp,
            ['getAdminProductsConsistencyDetails-infinite']
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminProductConsistencyDescriptionsResp, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getGetAdminProductsConsistencyDetailsInfiniteQueryKey(),
        async (context) =>
            convertFetchResponseToReactQueryResponse(await new ProductsApi().getAdminProductsConsistencyDetails()),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type PostAdminAssignProductsToGroupSaleQueryOptions = UseQueryOptions<
    void,
    Array<Error>,
    void,
    ['postAdminAssignProductsToGroupSale', ProductsApiPostAdminAssignProductsToGroupSaleRequest]
>;

let usePostAdminAssignProductsToGroupSaleQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: ProductsApiPostAdminAssignProductsToGroupSaleRequest,
          options?: PostAdminAssignProductsToGroupSaleQueryOptions
      ) => PostAdminAssignProductsToGroupSaleQueryOptions | undefined)
    | undefined = undefined;

export function registerUsePostAdminAssignProductsToGroupSaleQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: ProductsApiPostAdminAssignProductsToGroupSaleRequest,
        options?: PostAdminAssignProductsToGroupSaleQueryOptions
    ) => PostAdminAssignProductsToGroupSaleQueryOptions | undefined
) {
    usePostAdminAssignProductsToGroupSaleQueryGlobalOptions = callback;
}

export function getPostAdminAssignProductsToGroupSaleQueryKey(
    params: ProductsApiPostAdminAssignProductsToGroupSaleRequest
): ['postAdminAssignProductsToGroupSale', ProductsApiPostAdminAssignProductsToGroupSaleRequest] {
    return ['postAdminAssignProductsToGroupSale', params];
}

export function usePostAdminAssignProductsToGroupSaleQuery(
    params: ProductsApiPostAdminAssignProductsToGroupSaleRequest,
    options?: PostAdminAssignProductsToGroupSaleQueryOptions
): UseQueryResult<void, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getPostAdminAssignProductsToGroupSaleQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(
                await new ProductsApi().postAdminAssignProductsToGroupSale(params, {signal})
            ),
        {
            ...options,
            ...usePostAdminAssignProductsToGroupSaleQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type PostAdminAssignProductsToGroupSaleMutationOptions = UseMutationOptions<
    void,
    Array<Error>,
    ProductsApiPostAdminAssignProductsToGroupSaleRequest
>;

let usePostAdminAssignProductsToGroupSaleMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: PostAdminAssignProductsToGroupSaleMutationOptions
      ) => PostAdminAssignProductsToGroupSaleMutationOptions | undefined)
    | undefined = undefined;

export function registerUsePostAdminAssignProductsToGroupSaleMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: PostAdminAssignProductsToGroupSaleMutationOptions
    ) => PostAdminAssignProductsToGroupSaleMutationOptions | undefined
) {
    usePostAdminAssignProductsToGroupSaleMutationGlobalOptions = callback;
}

export function usePostAdminAssignProductsToGroupSaleMutation(
    options?: PostAdminAssignProductsToGroupSaleMutationOptions
): UseMutationResult<void, Array<runtime.ApiError>, ProductsApiPostAdminAssignProductsToGroupSaleRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(
                await new ProductsApi().postAdminAssignProductsToGroupSale(params)
            ),
        {
            ...options,
            ...usePostAdminAssignProductsToGroupSaleMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getPostAdminAssignProductsToGroupSaleInfiniteQueryKey(
    params: ProductsApiPostAdminAssignProductsToGroupSaleRequest
): ['postAdminAssignProductsToGroupSale-infinite', ProductsApiPostAdminAssignProductsToGroupSaleRequest] {
    return ['postAdminAssignProductsToGroupSale-infinite', params];
}

export function usePostAdminAssignProductsToGroupSaleInfiniteQuery(
    params: ProductsApiPostAdminAssignProductsToGroupSaleRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            void,
            Array<runtime.ApiError>,
            void,
            void,
            ['postAdminAssignProductsToGroupSale-infinite', ProductsApiPostAdminAssignProductsToGroupSaleRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<void, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getPostAdminAssignProductsToGroupSaleInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new ProductsApi().postAdminAssignProductsToGroupSale({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type PostAdminAttachImagesQueryOptions = UseQueryOptions<
    void,
    Array<Error>,
    void,
    ['postAdminAttachImages', ProductsApiPostAdminAttachImagesRequest]
>;

let usePostAdminAttachImagesQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: ProductsApiPostAdminAttachImagesRequest,
          options?: PostAdminAttachImagesQueryOptions
      ) => PostAdminAttachImagesQueryOptions | undefined)
    | undefined = undefined;

export function registerUsePostAdminAttachImagesQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: ProductsApiPostAdminAttachImagesRequest,
        options?: PostAdminAttachImagesQueryOptions
    ) => PostAdminAttachImagesQueryOptions | undefined
) {
    usePostAdminAttachImagesQueryGlobalOptions = callback;
}

export function getPostAdminAttachImagesQueryKey(
    params: ProductsApiPostAdminAttachImagesRequest
): ['postAdminAttachImages', ProductsApiPostAdminAttachImagesRequest] {
    return ['postAdminAttachImages', params];
}

export function usePostAdminAttachImagesQuery(
    params: ProductsApiPostAdminAttachImagesRequest,
    options?: PostAdminAttachImagesQueryOptions
): UseQueryResult<void, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getPostAdminAttachImagesQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new ProductsApi().postAdminAttachImages(params, {signal})),
        {
            ...options,
            ...usePostAdminAttachImagesQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type PostAdminAttachImagesMutationOptions = UseMutationOptions<
    void,
    Array<Error>,
    ProductsApiPostAdminAttachImagesRequest
>;

let usePostAdminAttachImagesMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: PostAdminAttachImagesMutationOptions
      ) => PostAdminAttachImagesMutationOptions | undefined)
    | undefined = undefined;

export function registerUsePostAdminAttachImagesMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: PostAdminAttachImagesMutationOptions
    ) => PostAdminAttachImagesMutationOptions | undefined
) {
    usePostAdminAttachImagesMutationGlobalOptions = callback;
}

export function usePostAdminAttachImagesMutation(
    options?: PostAdminAttachImagesMutationOptions
): UseMutationResult<void, Array<runtime.ApiError>, ProductsApiPostAdminAttachImagesRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new ProductsApi().postAdminAttachImages(params)),
        {
            ...options,
            ...usePostAdminAttachImagesMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getPostAdminAttachImagesInfiniteQueryKey(
    params: ProductsApiPostAdminAttachImagesRequest
): ['postAdminAttachImages-infinite', ProductsApiPostAdminAttachImagesRequest] {
    return ['postAdminAttachImages-infinite', params];
}

export function usePostAdminAttachImagesInfiniteQuery(
    params: ProductsApiPostAdminAttachImagesRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            void,
            Array<runtime.ApiError>,
            void,
            void,
            ['postAdminAttachImages-infinite', ProductsApiPostAdminAttachImagesRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<void, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getPostAdminAttachImagesInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new ProductsApi().postAdminAttachImages({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type PostAdminPrintLabelQueryOptions = UseQueryOptions<
    AdminPrintLabelResponse,
    Array<Error>,
    AdminPrintLabelResponse,
    ['postAdminPrintLabel', ProductsApiPostAdminPrintLabelRequest]
>;

let usePostAdminPrintLabelQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: ProductsApiPostAdminPrintLabelRequest,
          options?: PostAdminPrintLabelQueryOptions
      ) => PostAdminPrintLabelQueryOptions | undefined)
    | undefined = undefined;

export function registerUsePostAdminPrintLabelQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: ProductsApiPostAdminPrintLabelRequest,
        options?: PostAdminPrintLabelQueryOptions
    ) => PostAdminPrintLabelQueryOptions | undefined
) {
    usePostAdminPrintLabelQueryGlobalOptions = callback;
}

export function getPostAdminPrintLabelQueryKey(
    params: ProductsApiPostAdminPrintLabelRequest
): ['postAdminPrintLabel', ProductsApiPostAdminPrintLabelRequest] {
    return ['postAdminPrintLabel', params];
}

export function usePostAdminPrintLabelQuery(
    params: ProductsApiPostAdminPrintLabelRequest,
    options?: PostAdminPrintLabelQueryOptions
): UseQueryResult<AdminPrintLabelResponse, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getPostAdminPrintLabelQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new ProductsApi().postAdminPrintLabel(params, {signal})),
        {
            ...options,
            ...usePostAdminPrintLabelQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type PostAdminPrintLabelMutationOptions = UseMutationOptions<
    AdminPrintLabelResponse,
    Array<Error>,
    ProductsApiPostAdminPrintLabelRequest
>;

let usePostAdminPrintLabelMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: PostAdminPrintLabelMutationOptions
      ) => PostAdminPrintLabelMutationOptions | undefined)
    | undefined = undefined;

export function registerUsePostAdminPrintLabelMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: PostAdminPrintLabelMutationOptions
    ) => PostAdminPrintLabelMutationOptions | undefined
) {
    usePostAdminPrintLabelMutationGlobalOptions = callback;
}

export function usePostAdminPrintLabelMutation(
    options?: PostAdminPrintLabelMutationOptions
): UseMutationResult<AdminPrintLabelResponse, Array<runtime.ApiError>, ProductsApiPostAdminPrintLabelRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) => convertFetchResponseToReactQueryResponse(await new ProductsApi().postAdminPrintLabel(params)),
        {
            ...options,
            ...usePostAdminPrintLabelMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getPostAdminPrintLabelInfiniteQueryKey(
    params: ProductsApiPostAdminPrintLabelRequest
): ['postAdminPrintLabel-infinite', ProductsApiPostAdminPrintLabelRequest] {
    return ['postAdminPrintLabel-infinite', params];
}

export function usePostAdminPrintLabelInfiniteQuery(
    params: ProductsApiPostAdminPrintLabelRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminPrintLabelResponse,
            Array<runtime.ApiError>,
            AdminPrintLabelResponse,
            AdminPrintLabelResponse,
            ['postAdminPrintLabel-infinite', ProductsApiPostAdminPrintLabelRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminPrintLabelResponse, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getPostAdminPrintLabelInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new ProductsApi().postAdminPrintLabel({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type PostAdminProductCreateQueryOptions = UseQueryOptions<
    AdminProductCreateResp,
    Array<Error>,
    AdminProductCreateResp,
    ['postAdminProductCreate', ProductsApiPostAdminProductCreateRequest]
>;

let usePostAdminProductCreateQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: ProductsApiPostAdminProductCreateRequest,
          options?: PostAdminProductCreateQueryOptions
      ) => PostAdminProductCreateQueryOptions | undefined)
    | undefined = undefined;

export function registerUsePostAdminProductCreateQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: ProductsApiPostAdminProductCreateRequest,
        options?: PostAdminProductCreateQueryOptions
    ) => PostAdminProductCreateQueryOptions | undefined
) {
    usePostAdminProductCreateQueryGlobalOptions = callback;
}

export function getPostAdminProductCreateQueryKey(
    params: ProductsApiPostAdminProductCreateRequest
): ['postAdminProductCreate', ProductsApiPostAdminProductCreateRequest] {
    return ['postAdminProductCreate', params];
}

export function usePostAdminProductCreateQuery(
    params: ProductsApiPostAdminProductCreateRequest,
    options?: PostAdminProductCreateQueryOptions
): UseQueryResult<AdminProductCreateResp, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getPostAdminProductCreateQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new ProductsApi().postAdminProductCreate(params, {signal})),
        {
            ...options,
            ...usePostAdminProductCreateQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type PostAdminProductCreateMutationOptions = UseMutationOptions<
    AdminProductCreateResp,
    Array<Error>,
    ProductsApiPostAdminProductCreateRequest
>;

let usePostAdminProductCreateMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: PostAdminProductCreateMutationOptions
      ) => PostAdminProductCreateMutationOptions | undefined)
    | undefined = undefined;

export function registerUsePostAdminProductCreateMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: PostAdminProductCreateMutationOptions
    ) => PostAdminProductCreateMutationOptions | undefined
) {
    usePostAdminProductCreateMutationGlobalOptions = callback;
}

export function usePostAdminProductCreateMutation(
    options?: PostAdminProductCreateMutationOptions
): UseMutationResult<AdminProductCreateResp, Array<runtime.ApiError>, ProductsApiPostAdminProductCreateRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new ProductsApi().postAdminProductCreate(params)),
        {
            ...options,
            ...usePostAdminProductCreateMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getPostAdminProductCreateInfiniteQueryKey(
    params: ProductsApiPostAdminProductCreateRequest
): ['postAdminProductCreate-infinite', ProductsApiPostAdminProductCreateRequest] {
    return ['postAdminProductCreate-infinite', params];
}

export function usePostAdminProductCreateInfiniteQuery(
    params: ProductsApiPostAdminProductCreateRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminProductCreateResp,
            Array<runtime.ApiError>,
            AdminProductCreateResp,
            AdminProductCreateResp,
            ['postAdminProductCreate-infinite', ProductsApiPostAdminProductCreateRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminProductCreateResp, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getPostAdminProductCreateInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new ProductsApi().postAdminProductCreate({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type PostAdminProductListQueryOptions = UseQueryOptions<
    AdminProductListResp,
    Array<Error>,
    AdminProductListResp,
    ['postAdminProductList', ProductsApiPostAdminProductListRequest?]
>;

let usePostAdminProductListQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params?: ProductsApiPostAdminProductListRequest,
          options?: PostAdminProductListQueryOptions
      ) => PostAdminProductListQueryOptions | undefined)
    | undefined = undefined;

export function registerUsePostAdminProductListQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params?: ProductsApiPostAdminProductListRequest,
        options?: PostAdminProductListQueryOptions
    ) => PostAdminProductListQueryOptions | undefined
) {
    usePostAdminProductListQueryGlobalOptions = callback;
}

export function getPostAdminProductListQueryKey(
    params?: ProductsApiPostAdminProductListRequest
): ['postAdminProductList', ProductsApiPostAdminProductListRequest?] {
    return params !== undefined ? ['postAdminProductList', params] : ['postAdminProductList'];
}

export function usePostAdminProductListQuery(
    params?: ProductsApiPostAdminProductListRequest,
    options?: PostAdminProductListQueryOptions
): UseQueryResult<AdminProductListResp, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getPostAdminProductListQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new ProductsApi().postAdminProductList(params, {signal})),
        {
            ...options,
            ...usePostAdminProductListQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type PostAdminProductListMutationOptions = UseMutationOptions<
    AdminProductListResp,
    Array<Error>,
    ProductsApiPostAdminProductListRequest | undefined
>;

let usePostAdminProductListMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: PostAdminProductListMutationOptions
      ) => PostAdminProductListMutationOptions | undefined)
    | undefined = undefined;

export function registerUsePostAdminProductListMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: PostAdminProductListMutationOptions
    ) => PostAdminProductListMutationOptions | undefined
) {
    usePostAdminProductListMutationGlobalOptions = callback;
}

export function usePostAdminProductListMutation(
    options?: PostAdminProductListMutationOptions
): UseMutationResult<
    AdminProductListResp,
    Array<runtime.ApiError>,
    ProductsApiPostAdminProductListRequest | undefined
> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new ProductsApi().postAdminProductList(params)),
        {
            ...options,
            ...usePostAdminProductListMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getPostAdminProductListInfiniteQueryKey(
    params?: ProductsApiPostAdminProductListRequest
): ['postAdminProductList-infinite', ProductsApiPostAdminProductListRequest | undefined] {
    return ['postAdminProductList-infinite', params];
}

export function usePostAdminProductListInfiniteQuery(
    params?: ProductsApiPostAdminProductListRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminProductListResp,
            Array<runtime.ApiError>,
            AdminProductListResp,
            AdminProductListResp,
            ['postAdminProductList-infinite', ProductsApiPostAdminProductListRequest | undefined]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminProductListResp, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getPostAdminProductListInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new ProductsApi().postAdminProductList({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type PostAdminRotateImageQueryOptions = UseQueryOptions<
    AdminProductDetailImage,
    Array<Error>,
    AdminProductDetailImage,
    ['postAdminRotateImage', ProductsApiPostAdminRotateImageRequest]
>;

let usePostAdminRotateImageQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: ProductsApiPostAdminRotateImageRequest,
          options?: PostAdminRotateImageQueryOptions
      ) => PostAdminRotateImageQueryOptions | undefined)
    | undefined = undefined;

export function registerUsePostAdminRotateImageQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: ProductsApiPostAdminRotateImageRequest,
        options?: PostAdminRotateImageQueryOptions
    ) => PostAdminRotateImageQueryOptions | undefined
) {
    usePostAdminRotateImageQueryGlobalOptions = callback;
}

export function getPostAdminRotateImageQueryKey(
    params: ProductsApiPostAdminRotateImageRequest
): ['postAdminRotateImage', ProductsApiPostAdminRotateImageRequest] {
    return ['postAdminRotateImage', params];
}

export function usePostAdminRotateImageQuery(
    params: ProductsApiPostAdminRotateImageRequest,
    options?: PostAdminRotateImageQueryOptions
): UseQueryResult<AdminProductDetailImage, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getPostAdminRotateImageQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new ProductsApi().postAdminRotateImage(params, {signal})),
        {
            ...options,
            ...usePostAdminRotateImageQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type PostAdminRotateImageMutationOptions = UseMutationOptions<
    AdminProductDetailImage,
    Array<Error>,
    ProductsApiPostAdminRotateImageRequest
>;

let usePostAdminRotateImageMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: PostAdminRotateImageMutationOptions
      ) => PostAdminRotateImageMutationOptions | undefined)
    | undefined = undefined;

export function registerUsePostAdminRotateImageMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: PostAdminRotateImageMutationOptions
    ) => PostAdminRotateImageMutationOptions | undefined
) {
    usePostAdminRotateImageMutationGlobalOptions = callback;
}

export function usePostAdminRotateImageMutation(
    options?: PostAdminRotateImageMutationOptions
): UseMutationResult<AdminProductDetailImage, Array<runtime.ApiError>, ProductsApiPostAdminRotateImageRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new ProductsApi().postAdminRotateImage(params)),
        {
            ...options,
            ...usePostAdminRotateImageMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getPostAdminRotateImageInfiniteQueryKey(
    params: ProductsApiPostAdminRotateImageRequest
): ['postAdminRotateImage-infinite', ProductsApiPostAdminRotateImageRequest] {
    return ['postAdminRotateImage-infinite', params];
}

export function usePostAdminRotateImageInfiniteQuery(
    params: ProductsApiPostAdminRotateImageRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminProductDetailImage,
            Array<runtime.ApiError>,
            AdminProductDetailImage,
            AdminProductDetailImage,
            ['postAdminRotateImage-infinite', ProductsApiPostAdminRotateImageRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminProductDetailImage, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getPostAdminRotateImageInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new ProductsApi().postAdminRotateImage({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type PostAdminUpdateProductsStatusQueryOptions = UseQueryOptions<
    void,
    Array<Error>,
    void,
    ['postAdminUpdateProductsStatus', ProductsApiPostAdminUpdateProductsStatusRequest]
>;

let usePostAdminUpdateProductsStatusQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: ProductsApiPostAdminUpdateProductsStatusRequest,
          options?: PostAdminUpdateProductsStatusQueryOptions
      ) => PostAdminUpdateProductsStatusQueryOptions | undefined)
    | undefined = undefined;

export function registerUsePostAdminUpdateProductsStatusQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: ProductsApiPostAdminUpdateProductsStatusRequest,
        options?: PostAdminUpdateProductsStatusQueryOptions
    ) => PostAdminUpdateProductsStatusQueryOptions | undefined
) {
    usePostAdminUpdateProductsStatusQueryGlobalOptions = callback;
}

export function getPostAdminUpdateProductsStatusQueryKey(
    params: ProductsApiPostAdminUpdateProductsStatusRequest
): ['postAdminUpdateProductsStatus', ProductsApiPostAdminUpdateProductsStatusRequest] {
    return ['postAdminUpdateProductsStatus', params];
}

export function usePostAdminUpdateProductsStatusQuery(
    params: ProductsApiPostAdminUpdateProductsStatusRequest,
    options?: PostAdminUpdateProductsStatusQueryOptions
): UseQueryResult<void, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getPostAdminUpdateProductsStatusQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(
                await new ProductsApi().postAdminUpdateProductsStatus(params, {signal})
            ),
        {
            ...options,
            ...usePostAdminUpdateProductsStatusQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type PostAdminUpdateProductsStatusMutationOptions = UseMutationOptions<
    void,
    Array<Error>,
    ProductsApiPostAdminUpdateProductsStatusRequest
>;

let usePostAdminUpdateProductsStatusMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: PostAdminUpdateProductsStatusMutationOptions
      ) => PostAdminUpdateProductsStatusMutationOptions | undefined)
    | undefined = undefined;

export function registerUsePostAdminUpdateProductsStatusMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: PostAdminUpdateProductsStatusMutationOptions
    ) => PostAdminUpdateProductsStatusMutationOptions | undefined
) {
    usePostAdminUpdateProductsStatusMutationGlobalOptions = callback;
}

export function usePostAdminUpdateProductsStatusMutation(
    options?: PostAdminUpdateProductsStatusMutationOptions
): UseMutationResult<void, Array<runtime.ApiError>, ProductsApiPostAdminUpdateProductsStatusRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new ProductsApi().postAdminUpdateProductsStatus(params)),
        {
            ...options,
            ...usePostAdminUpdateProductsStatusMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getPostAdminUpdateProductsStatusInfiniteQueryKey(
    params: ProductsApiPostAdminUpdateProductsStatusRequest
): ['postAdminUpdateProductsStatus-infinite', ProductsApiPostAdminUpdateProductsStatusRequest] {
    return ['postAdminUpdateProductsStatus-infinite', params];
}

export function usePostAdminUpdateProductsStatusInfiniteQuery(
    params: ProductsApiPostAdminUpdateProductsStatusRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            void,
            Array<runtime.ApiError>,
            void,
            void,
            ['postAdminUpdateProductsStatus-infinite', ProductsApiPostAdminUpdateProductsStatusRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<void, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getPostAdminUpdateProductsStatusInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new ProductsApi().postAdminUpdateProductsStatus({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type PutAdminProductUpdateQueryOptions = UseQueryOptions<
    void,
    Array<Error>,
    void,
    ['putAdminProductUpdate', ProductsApiPutAdminProductUpdateRequest]
>;

let usePutAdminProductUpdateQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: ProductsApiPutAdminProductUpdateRequest,
          options?: PutAdminProductUpdateQueryOptions
      ) => PutAdminProductUpdateQueryOptions | undefined)
    | undefined = undefined;

export function registerUsePutAdminProductUpdateQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: ProductsApiPutAdminProductUpdateRequest,
        options?: PutAdminProductUpdateQueryOptions
    ) => PutAdminProductUpdateQueryOptions | undefined
) {
    usePutAdminProductUpdateQueryGlobalOptions = callback;
}

export function getPutAdminProductUpdateQueryKey(
    params: ProductsApiPutAdminProductUpdateRequest
): ['putAdminProductUpdate', ProductsApiPutAdminProductUpdateRequest] {
    return ['putAdminProductUpdate', params];
}

export function usePutAdminProductUpdateQuery(
    params: ProductsApiPutAdminProductUpdateRequest,
    options?: PutAdminProductUpdateQueryOptions
): UseQueryResult<void, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getPutAdminProductUpdateQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new ProductsApi().putAdminProductUpdate(params, {signal})),
        {
            ...options,
            ...usePutAdminProductUpdateQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type PutAdminProductUpdateMutationOptions = UseMutationOptions<
    void,
    Array<Error>,
    ProductsApiPutAdminProductUpdateRequest
>;

let usePutAdminProductUpdateMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: PutAdminProductUpdateMutationOptions
      ) => PutAdminProductUpdateMutationOptions | undefined)
    | undefined = undefined;

export function registerUsePutAdminProductUpdateMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: PutAdminProductUpdateMutationOptions
    ) => PutAdminProductUpdateMutationOptions | undefined
) {
    usePutAdminProductUpdateMutationGlobalOptions = callback;
}

export function usePutAdminProductUpdateMutation(
    options?: PutAdminProductUpdateMutationOptions
): UseMutationResult<void, Array<runtime.ApiError>, ProductsApiPutAdminProductUpdateRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new ProductsApi().putAdminProductUpdate(params)),
        {
            ...options,
            ...usePutAdminProductUpdateMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getPutAdminProductUpdateInfiniteQueryKey(
    params: ProductsApiPutAdminProductUpdateRequest
): ['putAdminProductUpdate-infinite', ProductsApiPutAdminProductUpdateRequest] {
    return ['putAdminProductUpdate-infinite', params];
}

export function usePutAdminProductUpdateInfiniteQuery(
    params: ProductsApiPutAdminProductUpdateRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            void,
            Array<runtime.ApiError>,
            void,
            void,
            ['putAdminProductUpdate-infinite', ProductsApiPutAdminProductUpdateRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<void, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getPutAdminProductUpdateInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new ProductsApi().putAdminProductUpdate({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}
